import { formLabelClasses } from '@mui/material';

export const muiFormLabelOverrides = {
	styleOverrides: {
		root: () => {
			return {
				[`.${formLabelClasses.asterisk}`]: { opacity: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 0 : 1 },
			};
		},
	},
};
